import React from 'react';
import SiteLogo from './SiteLogo';
import NavList from './NavList';
import { useContentful } from '../contentful/ContentContext';
import './Header.scss';

const Header = () => {
  const { getUiImage, getUiText } = useContentful();
  const asset = getUiImage('UI.HeroImage');
  const subtitle = getUiText('UI.PageSubtitle');

  return (
    <header className="siteHeader">
      {asset && (
        <img
          src={`https:${asset.fields.file.url}`}
          alt={asset.fields.description || asset.fields.title}
          className="siteHeader__image"
        />
      )}
      <div className="siteHeader__brand">
        <div>
          <SiteLogo size="large" color="white" />
          {subtitle && <p className="siteHeader__subtitle">{subtitle}</p>}
        </div>
        <NavList variant="hero" size="large" />
      </div>
    </header>
  );
};

export default Header;
